angular.module('LeasePilot').directive('editorControl', [
  '$rootScope',
  '$timeout',
  '$compile',
  'DealTermsImportService',
  function($rootScope, $timeout, $compile, DealTermsImportService) {
    const editorControlLink = function(scope, element, attr) {
      $rootScope.$on('leaseStatusChanged', function(event, status) {
        if (status.lock) {
          scope.disableControl();
        } else {
          scope.enableControl();
        }
      });
    
      // insert control-title
      var headerKey = null;
      if (attr.for) {
        headerKey = attr.for
          .replace(/^lease/i, 'title')
          .replace('[$index]', '');
      } else {
        headerKey = '';
        console.error(`missing 'for' attribute on`, element);
      }
    
      var headerLabel = angular.element('<editor-label></editor-label>', {
        for: headerKey,
        class: 'control-title',
      });

      $compile(headerLabel)(scope).insertBefore(element);
    
      scope.enableControl = function() {
        element.removeClass('disabled');
        element.find('*').removeAttr('disabled');
      };
    
      scope.disableControl = function() {
        element.addClass('disabled');
        //disable simple input
        element.find('input').attr('disabled', true);
        //disable select
        element.find('select').attr('disabled', true);
        //disable textarea
        element.find('textarea').attr('disabled', true);
        //disable checkbox
        element.find('md-checkbox').attr('disabled', true);
        //disable radio
        element.find('md-radio-group md-radio-button').attr('disabled', true);
        //disable date
        element
          .find('lp-date-picker input, lp-date-picker button')
          .attr('disabled', true);
        //disable links
        element.find('.remove-attachment').hide();
      };
    
      var acceptButton = null;
      var rejectButton = null;
      var toggleGroup = null;
      var fieldPath = attr.for ? attr.for.replace(/^lease\./, '') : null;

      // Evaluate fieldPath based on scope to resolve $index and $parent.$index
      function evaluateFieldPath(path) {
        if (!path) return null;
        
        // Try to get index from scope attributes first (more reliable)
        var index = attr.index !== undefined ? attr.index : (scope.index !== undefined ? scope.index : null);
        var parentIndex = attr.parentIndex !== undefined ? attr.parentIndex : (scope.parentIndex !== undefined ? scope.parentIndex : null);
        
        // Fallback to scope.$index if available
        if (index === null && scope.$index !== undefined) {
          index = scope.$index;
        }

        // Fallback to scope.$parent.$index if available
        if (parentIndex === null && scope.$parent.$index !== undefined) {
          parentIndex = scope.$parent.$index;
        }
        
        // Replace $parent.$index first (more specific)
        if (parentIndex !== null && path.indexOf('[$parent.$index]') !== -1) {
          path = path.replace(/\$parent\.\$index/g, parentIndex);
        }
        
        // Replace $index
        if (index !== null && path.indexOf('[$index]') !== -1) {
          path = path.replace(/\$index/g, index);
        }
        
        return path;
      }
      
      fieldPath = evaluateFieldPath(fieldPath);
      
      var label = element.find('label');

      function ensureLabel() {
        if (label && label.length) {
          return label;
        }
        label = element.find('label');
        return label;
      }

      function ensureToggleGroup() {
        if (toggleGroup) {
          return toggleGroup;
        }

        toggleGroup = angular.element('<span class="deal-terms-import-toggle-group"></span>');
        
        // Check if this is a checkbox control
        var isCheckbox = element.find('md-checkbox').length > 0;
        
        if (isCheckbox) {
          var checkboxLabel = element.find('.input-container .editor-label');
          // For checkboxes, add toggle group after checkboxLabel
          checkboxLabel.addClass('deal-terms-has-toggle');
          checkboxLabel.after(toggleGroup);
        } else if (label && label.length) {
          // For other controls with labels, add to the label
          label.addClass('deal-terms-has-toggle');
          label.append(toggleGroup);
        } else {
          // Fallback: add to headerLabel
          headerLabel.addClass('deal-terms-has-toggle');
          headerLabel.append(toggleGroup);
        }

        return toggleGroup;
      }

      // Helper function to format values for tooltip display
      function formatValueForTooltip(value) {
        if (value === null || value === undefined || value == "") {
          return '(empty)';
        }
        if (typeof value === 'boolean') {
          return value ? 'Yes' : 'No';
        }
        if (typeof value === 'number') {
          return String(value);
        }
        // For strings, truncate if too long
        var str = String(value);
        if (str.length > 100) {
          return str.substring(0, 97) + '...';
        }
        return str;
      }

      function ensureAcceptButton(fieldPath, tooltipText) {
        if (acceptButton) {
          // Update tooltip if text is provided
          if (tooltipText !== undefined) {
            acceptButton.attr('title', tooltipText);
          }
          return acceptButton;
        }

        // Default tooltip text if not provided
        tooltipText = tooltipText || 'Accept change';

        acceptButton = angular.element(
          '<button type="button" class="deal-terms-import-accept-btn">' +
            '<svg class="icon" style="width: 14px; height: 14px" viewBox="0 0 24 24">' +
              '<path fill="#62e767" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path>' +
            '</svg>' +
          '</button>'
        );
        acceptButton.attr('title', tooltipText);

        acceptButton.on('click', function(event) {
          event.stopPropagation();
          event.preventDefault();

          $timeout(function() {
            DealTermsImportService.acceptChangeForField(fieldPath);
          }, 0);
        });
        
        // Attach to the toggle group so it sits next to the reject icon
        var label = ensureLabel();
        var group = ensureToggleGroup(label);
        group.append(acceptButton);
        return acceptButton;
      }

      function ensureRejectButton(fieldPath, tooltipText) {
        if (rejectButton) {
          // Update tooltip if text is provided
          if (tooltipText !== undefined) {
            rejectButton.attr('title', tooltipText);
          }
          return rejectButton;
        }

        // Default tooltip text if not provided
        tooltipText = tooltipText || 'Reject change';

        rejectButton = angular.element(
          '<button type="button" class="deal-terms-import-reject-btn">' +
            '<svg class="icon" style="width: 14px; height: 14px" viewBox="0 0 24 24">' +
              '<path fill="#ff483e" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59' +
              'L13.41,12L19,6.41Z"></path>' +
            '</svg>' +
          '</button>'
        );
        rejectButton.attr('title', tooltipText);
        rejectButton.on('click', function(event) {
          event.stopPropagation();
          event.preventDefault();

          // Use $timeout to enter Angular digest safely
          $timeout(function() {
            DealTermsImportService.rejectChangeForField(fieldPath);
          }, 0);
        });

        // Attach to the toggle group so it sits next to the accept icon
        var label = ensureLabel();
        var group = ensureToggleGroup(label);
        group.append(rejectButton);
        return rejectButton;
      }

      // Check for pending changes and add highlighting / controls
      // NOTE: Buttons are always present in the DOM; visibility is handled via CSS
      // using .deal-terms-import-pending, .active, :hover, and :focus-within.
      function checkForPendingChanges() {
        if (!fieldPath || !DealTermsImportService.isImportActive) {
          return;
        }
        var change = DealTermsImportService.getChangeForField(fieldPath);

        if (change) {
          element.attr('data-field-path', fieldPath);
          element.addClass('deal-terms-import-pending');

          // Format tooltip values
          var acceptValue = formatValueForTooltip(change.after);
          var rejectValue = formatValueForTooltip(change.before);
          var acceptTooltipText = 'Accept: ' + acceptValue;
          var rejectTooltipText = 'Reject: ' + rejectValue;

          // Ensure toggle group/buttons exist once per control, passing tooltip text
          var label = ensureLabel();
          var acceptBtn = ensureAcceptButton(fieldPath, acceptTooltipText);
          var rejectBtn = ensureRejectButton(fieldPath, rejectTooltipText);

          // Reflect current decision state on element and buttons.
          // By default, changes are treated as accepted unless explicitly rejected.
          var decision = change.decision || 'accepted';
          var isAccepted = decision === 'accepted';
          var isRejected = decision === 'rejected';

          if (isAccepted) {
            element.addClass('deal-terms-import-accepted');
            element.removeClass('deal-terms-import-rejected');
            acceptBtn.addClass('active');
            rejectBtn.removeClass('active');
            // Disable accept button when accepted, enable reject button
            acceptBtn.attr('disabled', true);
            rejectBtn.removeAttr('disabled');
          } else if (isRejected) {
            element.addClass('deal-terms-import-rejected');
            element.removeClass('deal-terms-import-accepted');
            rejectBtn.addClass('active');
            acceptBtn.removeClass('active');
            // Disable reject button when rejected, enable accept button
            rejectBtn.attr('disabled', true);
            acceptBtn.removeAttr('disabled');
          } else {
            element.removeClass('deal-terms-import-accepted deal-terms-import-rejected');
            acceptBtn.removeClass('active');
            rejectBtn.removeClass('active');
            // Enable both buttons when no decision has been made
            acceptBtn.removeAttr('disabled');
            rejectBtn.removeAttr('disabled');
          }

          // Mark current change so CSS can always show its toggle group.
          // We use both a specific class and the generic 'active' class.
          var isCurrent =
            change === DealTermsImportService.pendingChanges[DealTermsImportService.currentChangeIndex];
          if (isCurrent) {
            element.addClass('deal-terms-import-active');
            element.addClass('active');
          } else {
            element.removeClass('deal-terms-import-active');
            element.removeClass('active');
          }
        } else {
          element.removeClass(
            'deal-terms-import-pending deal-terms-import-active active deal-terms-import-accepted deal-terms-import-rejected'
          );
          element.removeAttr('data-field-path');
        }
      }
      // When the user focuses or clicks the control, make its change the active one
      function handleActivateCurrent() {
        if (!fieldPath || !DealTermsImportService.isImportActive) return;
        $timeout(function() {
          DealTermsImportService.setCurrentChangeByFieldPath(fieldPath);
        }, 0);
      }

      element.on('click', handleActivateCurrent);
      element.on('focusin', handleActivateCurrent);
      
      // Listen for import events
      $rootScope.$on('dealTermsImport:started', function() {
        $timeout(checkForPendingChanges, 100);
      });
      
      $rootScope.$on('dealTermsImport:changeNavigated', function() {
        $timeout(checkForPendingChanges, 100);
      });

      $rootScope.$on('dealTermsImport:changeAccepted', function() {
        $timeout(checkForPendingChanges, 0);
      });

      $rootScope.$on('dealTermsImport:changeRejected', function() {
        $timeout(checkForPendingChanges, 0);
      });
      
      $rootScope.$on('dealTermsImport:finished', function() {
        element.removeClass('deal-terms-import-pending deal-terms-import-active active deal-terms-import-accepted deal-terms-import-rejected');
        element.removeAttr('data-field-path');
        
        // Remove accept/reject buttons and toggle group
        if (acceptButton && acceptButton.length) {
          acceptButton.remove();
          acceptButton = null;
        }
        if (rejectButton && rejectButton.length) {
          rejectButton.remove();
          rejectButton = null;
        }
        if (toggleGroup && toggleGroup.length) {
          toggleGroup.remove();
          toggleGroup = null;
        }
        
        // Remove the toggle class from label
        var label = element.find('label');
        if (label && label.length) {
          label.removeClass('deal-terms-has-toggle');
        }
        if (headerLabel && headerLabel.length) {
          headerLabel.removeClass('deal-terms-has-toggle');
        }
      });
      
      scope.init = function() {
        if ($rootScope.lease && $rootScope.lease.isLocked) {
          $timeout(function() {
            scope.disableControl();
          }, 0);
        }
        $(element).addClass('editor-control');
        if (element.find('input').attr('type') === 'number' && scope.for) {
          scope.for = Number(scope.for);
        }
    
        const el = element.get(0);
        const note = document.createElement("note");
    
        if (attr.for.startsWith("lease.")) {
          note.setAttribute("category", attr.for.replace("lease.", ""));
    
          if (el.firstElementChild) {
            el.insertBefore(note, el.firstElementChild);
            $compile(note)(scope);
          }
        }
        
        // Check for pending changes on init
        checkForPendingChanges();
      };
      scope.init();
    };
    
    return {
      restrict: 'E',
      scope: {
        for: '=',
        index: '@',
        parentIndex: '@',
      },
      link: editorControlLink,
    };
  },
]);
